module.exports = __webpack_public_path__ + "img/wechat.5707e9f0.svg";